import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, Fields, reduxForm, change } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import QueryString from 'query-string';
import {
  InputFieldBlock,
  DateFieldBlock,
  scrollToFirstError,
  SharedMessages as sharedMessages,
} from 'ecs-react-components/dist/index.es';
import { messages } from './VerifyIdentityForm.i18n';
import { loadPatientInviteResponseValidation }
  from '../../../redux/modules/signup/verify-identity/verify-identity-middleware';
import { setIsDedicatedWorkflow } from '../../../redux/modules/workflow/workflow-action-creator';


const fields = ['firstName', 'lastName', 'day', 'month', 'year'];

class VerifyIdentityForm extends Component {
  UNSAFE_componentWillMount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(true));
  }

  componentDidMount = () => {
    const params = QueryString.parse(location.search);
    if (params.pin) {
      this.props.dispatch(change('verifyIdentityForm', 'pin', params.pin));
    }
  }

  componentWillUnmount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(false));
  }

  onClickCancel = (event) => {
    event.preventDefault();
    this.props.history.push('/login');
  }

  onSubmit = (values) => {
    this.props.dispatch(loadPatientInviteResponseValidation(values));
  }

  onBackButtonEvent(event) {
    event.preventDefault();
    this.props.history.push('/login');
  }

  getInputFieldBlock(f, formattedMsg, fieldName) {
    return (<InputFieldBlock
      key={ f.input.name }
      id={ f.input.name }
      labelText={ formattedMsg }
      helpText={ <FormattedMessage { ...messages.helpText[fieldName] } /> }
      field={ f }
      lgSize={6}
      rowClass="mb-3"
    />);
  }

  buildVerificationFieldInput = (verificationField) => {
    const field = verificationField.toLowerCase();
    const params = QueryString.parse(location.search);
    const NestedInputComponent = (props) => { <input type="hidden" {...props} key="key-pin" />; }
    switch (field) {
      case 'pin':
        if (params.pin) {
          return (<Field name={field} component={ NestedInputComponent } />);
        }

        return (<Field name={field} component={(f) => this.getInputFieldBlock(f,
          <FormattedMessage { ...messages.form.pin } />,
          'pin')}
          key="key-pin"
        />);
      case 'mrn':
        return (<Field name={field} component={(f) => this.getInputFieldBlock(f,
            <FormattedMessage id="mrn"
              defaultMessage={this.props.patientIdentifierLabel}
            />,
            'mrn')}
          key="key-mrn"
        />);
      case 'ssn':
        return (<Field name={field} component={(f) => this.getInputFieldBlock(f,
            <FormattedMessage { ...messages.form.ssn } />,
            'ssn')}
          key="key-ssn"
        />);
      default:
        return '';
    }
  }

  renderVerificationFields = () => this.props.verificationFields.map(
    (field) => this.buildVerificationFieldInput(field));

  renderFields = (fieldsMeta) => {
    const { firstName, lastName, day, month, year } = fieldsMeta;
    if (this.props.languageCode) {
      moment.locale(this.props.languageCode.toLowerCase());
    } else {
      moment.locale('en');
    }
    const dateFormat = moment.localeData().longDateFormat('l');
    return (
      <div>
        <InputFieldBlock
          id={firstName.input.name}
          key={firstName.input.name}
          labelText={ <FormattedMessage { ...messages.form.firstName } /> }
          field={firstName}
          rowClass="mb-3"
          lgSize={6}
        />
        <InputFieldBlock
          id="lastName"
          key="lastName"
          labelText={ <FormattedMessage { ...messages.form.lastName } /> }
          field={lastName}
          rowClass="mb-3"
          lgSize={6}
        />
        <DateFieldBlock
          id="dateOfBirth"
          key="dateOfBirth"
          labelText={ <FormattedMessage { ...messages.form.dateOfBirth } />}
          dayField={day}
          monthField={month}
          yearField={year}
          dateFormat={dateFormat}
          lgSize={6}
          rowClass="mb-3"
        />
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Fields names={fields} component={this.renderFields} />
          {this.renderVerificationFields()}

          <button
            data-qa-item="next_button"
            data-toggle="modal"
            data-target="#next"
            className="btn btn-primary"
            href="signup2.html"
            aria-describedby="submitButtonDescription"
          >
            <FormattedMessage {...messages.button.next} />
          </button>
          &nbsp;
          <button
            data-qa-item="cancel_button"
            className="btn btn-link"
            onClick={this.onClickCancel}
            aria-describedby="cancelButtonDescription"
          >
            <FormattedMessage { ...messages.button.cancel } />
          </button>
        </form>
        <span hidden id="cancelButtonDescription">
          <FormattedMessage { ...sharedMessages.labels.openNewDialog} />
        </span>

        <span hidden id="submitButtonDescription">
          <FormattedMessage { ...sharedMessages.labels.openNewScreen} />
        </span>

      </div>
    );
  }
}

VerifyIdentityForm.propTypes = {
  dispatch: PropTypes.func,
  handleSubmit: PropTypes.func,
  verificationFields: PropTypes.array,
  patientIdentifierLabel: PropTypes.string,
  languageCode: PropTypes.string,
  history: PropTypes.object,
};

const formConfig = {
  form: 'verifyIdentityForm',
  onSubmitFail: (errors) => scrollToFirstError(errors, fields),
};

export default reduxForm(formConfig)(VerifyIdentityForm);
